import NProgress from 'nprogress' // progress bar
import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw, RouteLocationNormalized, Router } from 'vue-router'
import { mainRoutes, baseRoutes, Routes } from './router.config'
import { RouterEnum } from '@/enums/routerEnum'
import { useAppStore } from '@/store/app'
import { usePermissionStore } from '@/store/permission'
import { getToken } from '@/utils/token'
NProgress.configure({ showSpinner: false, easing: 'ease-in-out', speed: 300, trickleSpeed: 300 }) // NProgress Configuration

// 白名单应该包含基本静态路由
const WHITE_NAME_LIST: string[] = [] // 白名单
const getWhiteList = (routes: RouteRecordRaw[]) =>
	routes.forEach(item => {
		WHITE_NAME_LIST.push(item.path)
		getWhiteList(item.children || [])
	})
getWhiteList([...baseRoutes, ...Routes])
export const checkIsAnonymityPages = (to: RouteLocationNormalized) => {
	return WHITE_NAME_LIST.includes(to.path)
}

// 路由实例
export const router: Router = createRouter({
	history: createWebHistory('/admin/'),
	routes: baseRoutes,
	scrollBehavior: () => ({ left: 0, top: 0 }),
})
// reset router
export function resetRouter() {
	router.hasRoute('Main') && router.removeRoute('Main')
}

/**
 * 路由守卫
 */
router.beforeEach(async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
	NProgress.start()
	const appStore = useAppStore()
	const permissionStore = usePermissionStore()
	// if (!appStore.platformTitle) {
	// 	await appStore.getSysName()
	// }
	// 设置当前页面 title
	if (to.meta.title) {
		document.title = `${to.meta.title}-${appStore.sysNameOfCn}`
	}
	const token = getToken()
	//如果已经登录
	if (token) {
		!!appStore.token && (appStore.token = token)
		// 跳向登录页 && 不是刷新的情况  阻止
		if (to.path === RouterEnum.LOGIN_PAGE_PATH && from.fullPath !== '/') {
			return false
		}
		// 判断当前用户是否已拉取完user_info信息
		if (!appStore?.userInfo?.userId) {
			// 拉取user_info
			try {
				await Promise.all([appStore.getLoginUserDetail(), appStore.getAllDictList(), permissionStore.getMenu(), permissionStore.getUserMenuPermissions()])
				// 动态添加路由
				const menuRoutes = permissionStore.hamRouters
				mainRoutes.children = mainRoutes.children?.concat(menuRoutes, Routes)
				router.addRoute(mainRoutes)
				// 如果跳转到首页则 跳转 有权限路由列表的第一个路由?? 403
				// 否则原to导航路由跳转
				return to.path === RouterEnum.LOGIN_PAGE_PATH ? { path: RouterEnum.HOME_PAGE_PATH } : { ...to }
				// return to.path === RouterEnum.HOME_PAGE_PATH || to.path === RouterEnum.LOGIN_PAGE_PATH ? { name: menuRoutes[0]?.name ?? RouterEnum.PAGE_403 } : { ...to }
			} catch (error) {
				console.error(error)
				await appStore.logout()
				return RouterEnum.LOGIN_PAGE_PATH
			}
		}
		return true
	} else {
		//没有登录
		return checkIsAnonymityPages(to) ? true : { path: RouterEnum.LOGIN_PAGE_PATH }
	}
})

router.afterEach(() => {
	NProgress.done() // finish progress bar
})
